// extracted by mini-css-extract-plugin
export var printerCard = "_bd-1";
export var printerCardConfigured = "_bd-2";
export var printerCardError = "_bd-3";
export var printerCardsContainer = "_bd-0";
export var printerIcon = "_bd-8";
export var printerIconConfigured = "_bd-5";
export var printerIconContainer = "_bd-4";
export var printerIconError = "_bd-6";
export var printerIconUnconfigured = "_bd-7";
export var workstationsTableCard = "_bd-9";